import { Product, ProjectCategory } from '../types';

// Filter out portfolio-only items (not usable free tools)
const getUsableProjects = (projects: Product[]): Product[] => {
  return projects.filter(project => !project.isPortfolio);
};

export const getProjectCategories = (projects: Product[]): ProjectCategory[] => {
  const usableProjects = getUsableProjects(projects);
  const categories = new Map<string, number>();
  
  // Count projects in each category
  usableProjects.forEach(project => {
    const count = categories.get(project.category) || 0;
    categories.set(project.category, count + 1);
  });

  // Convert to array and sort by count
  const sortedCategories = Array.from(categories.entries())
    .map(([category, count]) => ({ category, count }))
    .sort((a, b) => b.count - a.count);

  // Add "All" option at the beginning
  return [{ category: 'all', count: usableProjects.length }, ...sortedCategories];
};

export const filterProjectsByCategory = (projects: Product[], selectedCategory: string): Product[] => {
  const usableProjects = getUsableProjects(projects);
  
  const filteredProjects = selectedCategory === 'all'
    ? usableProjects
    : usableProjects.filter(project => project.category === selectedCategory);

  // Always sort featured projects first
  return filteredProjects.sort((a, b) => {
    if (a.featured === b.featured) return 0;
    return a.featured ? -1 : 1;
  });
};